/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Period_LabelInputs */

const en_directory_vibebids_period_label = /** @type {(inputs: Directory_Vibebids_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leaderboard period`)
};

const zh_directory_vibebids_period_label = /** @type {(inputs: Directory_Vibebids_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`榜单时间范围`)
};

/**
* | output |
* | --- |
* | "Leaderboard period" |
*
* @param {Directory_Vibebids_Period_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_period_label = /** @type {((inputs?: Directory_Vibebids_Period_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Period_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_period_label(inputs)
	return zh_directory_vibebids_period_label(inputs)
});
export { directory_vibebids_period_label as "directory.vibebids.period_label" }